import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Divider } from './Divider';
interface Testimonial {
  quote: string;
  body: string;
  author: string;
  avatar: string;
}
const testimonials: Testimonial[] = [{
  quote: 'Volví a sentir la paz que había perdido',
  body: 'Llegué a este programa en un momento muy difícil de mi vida. Estaba constantemente preocupada por mis finanzas, mi familia y mi futuro. Oraba todos los días, pero sentía que mi mente no descansaba nunca. Durante los 30 días del Método R.E.V.E.L.A. aprendí a detenerme, escuchar a Dios y volver a confiar. Hoy me siento mucho más tranquila, con una fe más fuerte y una paz que hacía años no experimentaba. Este programa fue una verdadera bendición para mí.',
  author: 'María Elena G., 52 años',
  avatar: 'https://randomuser.me/api/portraits/women/65.jpg'
}, {
  quote: 'Pasé de la ansiedad a la confianza',
  body: 'Siempre he sido creyente, pero reconocí que estaba viviendo más desde el miedo que desde la fe. Mi mente estaba llena de preocupaciones y pensamientos negativos. Lo que más me ayudó fue la combinación de reflexión diaria, gratitud y las meditaciones guiadas. Poco a poco empecé a sentirme más ligera y a confiar nuevamente en que Dios tiene el control. Hoy enfrento los desafíos con una actitud completamente diferente.',
  author: 'Carolina R., 41 años',
  avatar: 'https://randomuser.me/api/portraits/women/41.jpg'
}, {
  quote: 'Nunca pensé que 15 minutos al día pudieran transformar tanto',
  body: 'Soy muy escéptico con este tipo de programas. Pero mi esposa me lo recomendó y decidí intentarlo. Lo que más me impactó fue la parte de la liberación. Llevaba años cargando miedos que nunca había entregado de verdad a Dios — solo de boca. Este proceso me enseñó a hacerlo de corazón. Mi mente está más tranquila, mi fe es más sólida y mi relación con Dios es más real que nunca.',
  author: 'Roberto M., 51 años',
  avatar: 'https://randomuser.me/api/portraits/men/52.jpg'
}, {
  quote: 'Lo recomiendo a cualquier creyente que sienta que algo le falta',
  body: 'Conocía la Biblia, asistía a mi iglesia cada semana y aun así vivía con una ansiedad constante que no podía explicar. El Método R.E.V.E.L.A. me ayudó a entender que no me faltaba información — me faltaba un proceso para vivirla. Cada día de los 30 fue una experiencia diferente. Terminé el programa con más paz, más claridad y una disciplina espiritual que hoy sigue siendo parte de mi vida diaria.',
  author: 'Daniela R., 32 años',
  avatar: 'https://randomuser.me/api/portraits/women/32.jpg'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#0B1A3A] py-20 px-6" style={{
    backgroundColor: "#5B401F",
    backgroundImage: "none"
  }} data-id="element-250" data-mp="3vitcskoh156a">
      <div className="max-w-5xl mx-auto" data-id="element-251" data-mp="2y2e4gojrys7c">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-center text-white mb-4" data-id="element-252" data-mp="2y1cr2dfadtmg">
          Historias de quienes ya vivieron sus 30 días
        </motion.h2>

        <Divider data-id="element-253" data-mp="1b5emzumqep3s" />

        <div className="grid md:grid-cols-2 gap-8" data-id="element-254" data-mp="1b4whe7e6iyj7">
          {testimonials.map((testimonial, index) => <motion.figure key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-[#F7F2E7] rounded-lg p-8 flex flex-col" data-id="element-255" data-mp="166lbg7r09869" data-mpi={index}>
              <div className="flex gap-1 mb-4" aria-label="5 de 5 estrellas" data-id="element-256" data-mp="sg83w6i0zvhg">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#E0B756] text-[#E0B756]" data-id="element-257" data-mp="neshob443ixh" data-mpi={i} />)}
              </div>

              <h3 className="text-xl font-bold text-[#0A1535] mb-4" data-id="element-258" data-mp="ijmvrcapm49e">
                “{testimonial.quote}”
              </h3>

              <blockquote className="text-[#0A1535]/80 leading-relaxed mb-6 flex-1" data-id="element-259" data-mp="2dkf617qwcqdc">
                {testimonial.body}
              </blockquote>

              <figcaption className="flex items-center gap-3" data-id="element-260" data-mp="2iji94mnbgmio">
                <img src={testimonial.avatar} alt={`Foto de ${testimonial.author}`} className="w-12 h-12 rounded-full object-cover border-2 border-[#E0B756]" loading="lazy" data-id="element-261" data-mp="23vx951lqn3ez" />
                <span className="text-[#C9A24B] font-semibold" data-id="element-262" data-mp="1uuqqomzj3ij3">
                  {testimonial.author}
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}